<template>
  <div>
    <div class="pb-3">
      <router-link :to="{ name: 'activist_task_edit', params: { id: $route.params.task_id } }"
        >Назад к задаче</router-link
      >
    </div>
    <v-row justify="space-between" no-gutters>
      <v-col lg="2" md="4" sm="6" v-for="f in availableFilters" :key="'filter' + f.key">
        <v-badge :content="counts[f.key] || '0'" :color="f.color" overlap>
          <v-chip
            outlined
            :disabled="!counts[f.key]"
            @click="addFilter(f.key)"
            :color="filters.includes(f.key) ? f.color : 'grey'"
            ><v-icon>{{ f.icon }}</v-icon
            >{{ f.name }}
          </v-chip>
        </v-badge>
      </v-col>
    </v-row>
    <Paginator
      v-if="totalPages > 0"
      :page="page"
      :total-page="totalPages"
      @page-changed="pageChanged"
    ></Paginator>
    <v-row v-if="loading" align-content="center">
      <v-progress-linear></v-progress-linear>
    </v-row>
    <v-list three-line v-if="takenTasks.length > 0">
      <template v-for="item in takenTasks">
        <TakenTaskListItem :key="item.id" :task="item"></TakenTaskListItem>
      </template>
    </v-list>
    <v-alert v-else dense border="left" type="warning"> Похоже ничего нет </v-alert>
  </div>
</template>

<script>
import {
  getTakenStatusIcon,
  getTakenStatusIconColor,
  getTakenTasksCountsResponse,
  getTakenTasksListResponse,
  getTakenTaskStatusDisplay,
  TakenTaskStatus,
} from '@/api/activist/task'
import TakenTaskListItem from '@/components/activist/TakenTaskListItem'
import Paginator from '@/components/Paginator'

const availableFilters = [
  {
    key: TakenTaskStatus.InProgress,
    icon: getTakenStatusIcon(TakenTaskStatus.InProgress),
    color: getTakenStatusIconColor(TakenTaskStatus.InProgress),
    name: getTakenTaskStatusDisplay(TakenTaskStatus.InProgress),
  },
  {
    key: TakenTaskStatus.Completed,
    icon: getTakenStatusIcon(TakenTaskStatus.Completed),
    color: getTakenStatusIconColor(TakenTaskStatus.Completed),
    name: getTakenTaskStatusDisplay(TakenTaskStatus.Completed),
  },
  {
    key: TakenTaskStatus.Approved,
    icon: getTakenStatusIcon(TakenTaskStatus.Approved),
    color: getTakenStatusIconColor(TakenTaskStatus.Approved),
    name: getTakenTaskStatusDisplay(TakenTaskStatus.Approved),
  },
  {
    key: TakenTaskStatus.Rejected,
    icon: getTakenStatusIcon(TakenTaskStatus.Rejected),
    color: getTakenStatusIconColor(TakenTaskStatus.Rejected),
    name: getTakenTaskStatusDisplay(TakenTaskStatus.Rejected),
  },
  {
    key: TakenTaskStatus.Cancelled,
    icon: getTakenStatusIcon(TakenTaskStatus.Cancelled),
    color: getTakenStatusIconColor(TakenTaskStatus.Cancelled),
    name: getTakenTaskStatusDisplay(TakenTaskStatus.Cancelled),
  },
]
export default {
  name: 'TakenTaskList',
  components: { TakenTaskListItem, Paginator },
  data() {
    return {
      takenTasks: [],
      page: 1,
      limit: 10,
      filters: [TakenTaskStatus.Completed],
      availableFilters: [...availableFilters],
      totalItems: 0,
      loading: true,
      counts: {},
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.limit)
    },
  },
  mounted() {
    this.updateList()
  },
  methods: {
    updateList() {
      this.getTakeTaskList()
      this.getTakenTasksCounts()
    },
    addFilter(filter) {
      if (this.filters.includes(filter)) {
        this.filters = this.filters.filter((x) => {
          return x !== filter
        })
      } else {
        this.filters.push(filter)
      }
      this.getTakeTaskList()
    },
    pageChanged(page) {
      this.page = page
      this.updateList()
    },
    getTakenTasksCounts() {
      getTakenTasksCountsResponse(this.axios, this.$route.params.task_id)
        .then((resp) => {
          this.counts = resp.data
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
    },
    getTakeTaskList() {
      this.loading = true
      getTakenTasksListResponse(this.axios, this.$route.params.task_id, {
        limit: this.limit,
        page: this.page,
        status: this.filters,
      })
        .then((resp) => {
          this.totalItems = Number(resp.headers['x-hub-total'])
          this.$set(this, 'takenTasks', resp.data || [])
        })
        .catch((err) => {
          this.showSnackbar(err, 'error')
        })
        .finally(() => (this.loading = false))
    },
  },
}
</script>
